<ng-container *ngrxLet="vm$ as vm">
  <se-fe-card tabindex="0">
    <se-fe-card-content class="service-offer" [class.hide-image]="!vm.hasImage">
      @if (vm.hasImage) {
        <div class="service-offer__image">
          <img class="" [src]="vm.image.src" alt="{{ vm.image.alt }}" />
        </div>
      }
      <div class="service-offer__details">
        <div class="service-offer-header">
          @if (vm.offer.logo) {
            <div
              class="service-offer-logo"
              [class.service-offer-logo--win-reality]="
                vm.offer.name.toLowerCase() === 'swingai'
              ">
              <img
                class="logo"
                [src]="vm.offer.logo.src"
                alt="{{ vm.offer.logo.alt }}" />
            </div>
          }
          <h2 markdown class="service-offer-headline">{{ vm.headline }}</h2>
          <div class="service-offer-quote">
            @if (
              vm.offer.quoteRequired() && (formToDisplay$ | async) !== 'select'
            ) {
              <span class="quote-loading-spinner">
                @if (vm.showQuoteSpinner && !vm.showPrice) {
                  <se-fe-spinner
                    [seFeDataSize]="500"
                    seFeDataAriaLabel="Quote loading"></se-fe-spinner>
                }
                @if (vm.showQuote) {
                  <span class="offer-price">
                    {{ vm.offer.quote?.cost | currency }}
                  </span>
                }
              </span>
            }
            @if (vm.showPrice && (formToDisplay$ | async) !== 'select') {
              <span class="offer-price">{{ vm.offer.price | currency }}</span>
            }
          </div>
          <div class="service-offer-fulfillment">
            <span>{{ vm.tagline }}</span>
          </div>
        </div>
        <app-divider></app-divider>
        <div class="service-offer-form">
          @switch (formToDisplay$ | async) {
            @case ('radio') {
              <app-radio-form
                #offerForm
                tabindex="0"
                [serviceOffer]="vm.offer"
                [contextData]="vm.contextData!"></app-radio-form>
            }
            @case ('checkbox') {
              <app-checkbox-form
                #offerForm
                [serviceOffer]="vm.offer"></app-checkbox-form>
            }
            @case ('cart-button') {
              <app-se-play-button
                #offerForm
                [serviceOffer]="vm.offer"></app-se-play-button>
            }
            @case ('select') {
              <app-select-form
                #offerForm
                [serviceOffer]="vm.offer"></app-select-form>
            }
          }
        </div>
      </div>
      <div class="service-offer__description">
        <app-divider></app-divider>
        <div class="service-offer-footer">
          <span markdown class="offer-description">
            {{ vm.description }}
          </span>
          <ul class="perils">
            @for (peril of vm.perils; track peril) {
              <li>
                <span class="peril">{{ peril }}</span>
              </li>
            }
          </ul>
        </div>
      </div>
    </se-fe-card-content>
  </se-fe-card>
  <app-add-on-footer
    class="footer"
    [disableNextButton]="!vm.formIsValid"
    (continueClick)="next()"
    (registerAnotherPersonClick)="registerAnotherPerson()"
    (continueToCheckoutClick)="complete()"></app-add-on-footer>
</ng-container>
